export { default } from './TechTag';
